export default "__VITE_ASSET__uVuFh5Fw__"